import { useFetchInstance } from '@/composables/api/useFetchInstance';
import { useFetchInstanceBasic } from '@/composables/api/useFetchInstanceBasic';
import { OrderResponse } from '@/types/Order';
import { UseFetchReturn } from '@vueuse/core';
export function useOrder() {
    async function addToCart(formData: FormData): Promise<UseFetchReturn<OrderResponse>> {
        return await useFetchInstance('/release/orders').post(formData).json();
    }

    async function uploadSaveFile(orderId: string, formData: FormData) {
        return await useFetchInstance(`/release/orders/${orderId}/uploadSaveFile`).post(formData);
    }

    async function getSaveByRecordId(recordId: string) {
        return await useFetchInstanceBasic(`/release/orders/${recordId}/save`).get().json();
    }

    return {
        addToCart,
        uploadSaveFile,
        getSaveByRecordId
    };
}
